export const env = {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001',
  NODE_ENV: import.meta.env.MODE || 'development',
  ENABLE_DEV_TOOLS:
    import.meta.env.VITE_ENABLE_DEV_TOOLS === 'true' || import.meta.env.MODE === 'development',
} as const;
